import { registerSingletonResourceWithStore } from '@/services/GenericSingletonResourceService'
import { registerListResourceWithStore } from '@/services/GenericListResourceService'
import store from '@/store'
import _ from 'lodash'
import { updatedDiff } from 'deep-object-diff'

registerSingletonResourceWithStore('disciplineSettings', 'discipline/settings', store)

registerListResourceWithStore('customInfractionTypes', 'discipline/custom-infraction-types', store)
registerListResourceWithStore('disciplineEventTypes', 'discipline/event-types', store)
registerListResourceWithStore('disciplinePolicies', 'discipline/policies', store)

setTimeout(() => {
  store.watch(
    state => ({
      disciplineEnabled: state.disciplineSettings.originalData.enabled
    }),
    syncSettings => {
      if (syncSettings.disciplineEnabled === undefined) {
        // This is a litmus test to determine whether Vue is just loading,
        // or whether something actually changed.
        return
      }
      // Get same keys in root state
      const rootSettings = _.pick(store.state, Object.keys(syncSettings))
      const updated = updatedDiff(rootSettings, syncSettings)
      if (!_.isEmpty(updated)) {
        store.dispatch('updateSession', updated)
      }
    }
  )
})

export default {
  name: 'discipline-settings-redirect',
  label: 'Attendance',
  link: 'attendance',
  path: 'attendance',
  props: true,
  icon: 'hundred-points',
  description: 'Define attendance expectations and consistent accountability rules.',
  redirect: to => {
    return { name: 'discipline-defaults', params: to.params }
  }
}
